// Cari kartı (Yeni Cari Ekle / Düzenle) kullanım rehberi. Metinler 'accounting' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'current.modals.addAccount.guide';

export const addAccountGuide = (t: TFunction): GuideContent => ({
  layout: 'card',
  title: t(`${G}.title`, 'Cari kartı nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Kart tek ekrandır: üstte cariyi tanıtan bilgiler, solda bölümler, sağda canlı özet. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    strip: t(`${G}.regions.strip`, 'Kimlik şeridi'),
    summary: t(`${G}.regions.summary`, 'Cari özeti'),
  },
  navItems: [
    t('current.modals.addAccount.layout.sections.taxinfo', 'Kimlik ve vergi'),
    t('current.modals.addAccount.layout.sections.contact', 'İletişim ve adres'),
    t('current.modals.addAccount.layout.sections.risk', 'Vade ve risk'),
    t('current.modals.addAccount.layout.sections.ecommerce', 'E-ticaret / B2B'),
    t('current.modals.addAccount.layout.sections.other', 'Şube ve notlar'),
  ],
  steps: [
    {
      region: 'strip',
      title: t(`${G}.s1.title`, '1. Vergi numarasını yazın'),
      text: t(`${G}.s1.text`, 'VKN (10 hane) yazınca tür "Tüzel", TC Kimlik No (11 hane) yazınca "Gerçek kişi" olur. Türü başlıktaki Tüzel / Gerçek seçiminden kendiniz de değiştirebilirsiniz.'),
      tips: [
        t(`${G}.s1.tip1`, 'Tüzel kişide VKN zorunludur; gerçek kişide TCKN isteğe bağlıdır.'),
      ],
    },
    {
      region: 'strip',
      title: t(`${G}.s2.title`, '2. "Sorgula" ile GİB kaydını getirin'),
      text: t(`${G}.s2.text`, 'Sorgula, firmanızın e-Fatura entegratörü (QNB eFinans, EDM, PavoPay…) üzerinden carinin e-Fatura mükellefi olup olmadığını ve GİB unvanını getirir. Unvan boşsa otomatik yazılır, doluysa öneri olarak gösterilir.'),
      tips: [
        t(`${G}.s2.tip1`, 'Entegrasyon tanımlı değilse Sorgula, nasıl ekleyeceğinizi adım adım anlatır.'),
        t(`${G}.s2.tip2`, 'e-Fatura mükellefi değilse faturaları e-Arşiv olarak kesilir.'),
      ],
    },
    {
      region: 'strip',
      title: t(`${G}.s3.title`, '3. Unvan ve grubu girin'),
      text: t(`${G}.s3.text`, 'Unvan / ad soyad ve cari grup zorunludur. Listede olmayan grubu yanındaki + ile ekleyebilirsiniz. Cari kodu boş bırakılırsa otomatik verilir.'),
    },
    {
      region: 'nav',
      title: t(`${G}.s4.title`, '4. Bölümler arasında gezin'),
      text: t(`${G}.s4.text`, 'Soldaki bölümler kartın geri kalanını gruplar. Kırmızı nokta, o bölümde eksik zorunlu alan olduğunu gösterir. Telefonda bölümler üstte sekme olarak görünür.'),
    },
    {
      region: 'content',
      title: t(`${G}.s5.title`, '5. Gerekli alanları doldurun'),
      text: t(`${G}.s5.text`, 'Yalnız ihtiyacınız olan bölümleri doldurmanız yeterli.'),
      tips: [
        t(`${G}.s5.tip1`, 'Vade ve risk: risk limiti boş = sınırsız, 0 = veresiye yok.'),
        t(`${G}.s5.tip2`, 'İletişim ve adres: il, 81 il listesinden seçilir.'),
        t(`${G}.s5.tip3`, 'E-ticaret / B2B: mağaza girişi açılacaksa e-posta da gerekir.'),
      ],
    },
    {
      region: 'summary',
      title: t(`${G}.s6.title`, '6. Özeti kontrol edin'),
      text: t(`${G}.s6.text`, 'Sağdaki özet; türü, e-Fatura / e-Arşiv durumunu, vade ve risk limitini gösterir. Eksik bir alana tıklarsanız ilgili yere gidersiniz.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s7.title`, '7. Kaydedin'),
      text: t(`${G}.s7.text`, 'Alt çubuk eksik alan sayısını gösterir. Eksik yoksa Kaydet\'e basın; "Kaydet ve yeni ekle" kaydedip boş bir kart açar. Sağ üstteki (i) düğmesi bu rehberi her zaman yeniden açar.'),
    },
  ],
});
